module.exports = __webpack_public_path__ + "img/door-open-solid.9854866c.svg";